import React from "react";
import { Heading } from "mondrian-react";

import mondrian from "core/config/theme";

import styled from "styled-components";

export const Container = styled.header`
  margin-top: ${mondrian.spacingStackXxs};
  margin-bottom: ${mondrian.spacingStackXs};
`;

export default function MainTitle(props) {
  return (
    <Container>
      <Heading {...props}>{props.children}</Heading>
    </Container>
  );
}
